export const styles = () => ({
  
});

export default styles;
